export default {
  title: 'Reimposta password',
  description: 'Invieremo un link per reimpostare la password alla tua email.',
  sent: 'Email inviata.',

  form: {
    email: {
      title: 'Email',
      placeholder: 'Inserisci email',
    },
    button: {
      title: 'Reimposta password',
    },
    error_messages: {
      error1: 'Informazioni mancanti',
    },
  },
};
